import gql from 'graphql-tag'
export default gql`mutation createChlorideClassMutation($chlorideClass: BaseChlorideClass!) {
  createChlorideClass(chlorideClass: $chlorideClass) {
    code
    description
    maxChloride
    id
  }
}`